import ListingMenus from 'containers/ListingMenus';
import React, { ReactNode, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import mainRoutes from 'routes/mainRoutes';
import { Row } from 'saladsoft-primitive';
import styled from 'styled-components';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { IconButton } from '@mui/material';
import Text from 'components/commons/Text';
import CheckinGuiedMenus from 'containers/CheckinGuiedMenus';
import SettingsMenus from 'containers/SettingsMenus';
import GuideMenus from 'containers/GuideMemus';
import useToken from 'hooks/useToken';
import { toast } from 'react-toastify';
import AirplanemodeActiveOutlinedIcon from '@mui/icons-material/AirplanemodeActiveOutlined';
import ServiceHelper from 'stores/ServiceHelper';
import PolicyMenus from 'containers/PolicyMenus';

const AdminLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { getUserInfo } = useToken();

  const [isContextActive, setIsContextActive] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [menuType, setMenuType] = useState<
    'listings' | 'checkin-guied' | 'settings' | 'guides' | 'management' | 'policy'
  >('listings');
  const [isAdmin, setIsAdmin] = useState(false);

  const routes = [
    { route: '/admin/listings', name: '숙소관리', key: 'listings' },
    { route: '/admin/guides/promotions', name: '이용안내', key: 'guides' },
    { route: '/admin/checkin-guide/wifi-info', name: '공통관리', key: 'checkin-guied' },
    { route: '/admin/policies/refund', name: '정책관리', key: 'policy' },
    { route: '/admin/settings/business-list', name: '시스템설정', key: 'settings' },
  ];

  const location = useLocation();

  // 현재 경로에 해당하는 route 객체 찾기
  const currentRoute = mainRoutes.find((route) => route.path === location.pathname);
  const useNav = currentRoute?.useNav !== false || false; // useNav가 없으면 false를 기본값으로 사용

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    toast.success('로그아웃 되었습니다.');
    navigate('/login');
  };

  const setRoleType = async () => {
    const roleType = await ServiceHelper.myAccountService?.getMyAccount();
    setIsAdmin(roleType?.data?.roleType === 'ADMIN');
  };

  useEffect(() => {
    setShowNav(useNav);
    setRoleType();
  }, [useNav]);

  useEffect(() => {
    ///admin/settings/business-list
    if (location.pathname.includes('listings')) {
      setMenuType('listings');
    } else if (location.pathname.includes('checkin-guide')) {
      setMenuType('checkin-guied');
    } else if (location.pathname.includes('admin/settings/')) {
      setMenuType('settings');
    } else if (location.pathname.includes('admin/guides/')) {
      setMenuType('guides');
    } else if (location.pathname.includes('management/users/')) {
      setMenuType('management');
    } else if (location.pathname.includes('admin/policies/')) {
      setMenuType('policy');
    }
  }, [location.pathname]);

  return (
    <Container onClick={() => setIsContextActive(false)}>
      <Row
        gap="30px"
        height="60px"
        justifyContent="space-between"
        width={'100%'}
        position="sticky"
        top={0}
        background={'#FBFBFB'}
        zIndex={10}
      >
        <div
          style={{ paddingLeft: 15, cursor: 'pointer' }}
          onClick={() => navigate('/management/reservations/daily')}
        >
          <img src="/images/butlerleelogo.png" alt="butlerlee" style={{ width: '150px' }} />
        </div>
        <Row gap="20px" flexGrow={1}>
          <>
            {routes.map((route) => (
              <ButtonStyle $isActive={route.key === menuType}>
                <Link to={route.route}>{route.name}</Link>
              </ButtonStyle>
            ))}
          </>
          <>
            {isAdmin && (
              <ButtonStyle>
                <Link
                  style={{
                    background: 'var(--point-color)',
                    color: '#fff',
                    padding: '5px 20px',
                    borderRadius: 10,
                    fontWeight: 600,
                    fontSize: 14,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                  to="/management/reservations/daily"
                >
                  <AirplanemodeActiveOutlinedIcon style={{ fontSize: 17 }} />
                  <span>운영관리</span>
                </Link>
              </ButtonStyle>
            )}
          </>
        </Row>
        <Row gap="5px" paddingRight="30px" justifyContent="flex-start">
          <IconButton style={{ background: '#fff' }} onClick={(e) => e.stopPropagation()}>
            <PermIdentityIcon />
          </IconButton>
          <div
            style={{ textAlign: 'left', position: 'relative', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation(); // 클릭 이벤트 전파 방지
              setIsContextActive(!isContextActive);
            }}
          >
            <Text type="H4" style={{ fontWeight: 600 }}>
              {getUserInfo()}
            </Text>
            <ContextWrapper $isActive={isContextActive} onClick={(e) => e.stopPropagation()}>
              <div
                onClick={() => {
                  logout();
                }}
              >
                <Text type="H4" style={{ fontWeight: 600 }}>
                  Logout
                </Text>
              </div>
            </ContextWrapper>
          </div>
        </Row>
      </Row>
      <Row
        width="100%"
        flexGrow={1}
        alignItems="flex-start"
        justifyContent="flex-start"
        boxSizing="border-box"
        padding={location.pathname !== '/admin/listings' ? '0 20px' : '0'}
      >
        <div style={{ position: 'sticky', top: 60, left: 0 }}>
          {showNav && (
            <div style={{ width: '300px' }}>
              {menuType === 'listings' && location.pathname !== '/admin/listings/new' && (
                <ListingMenus />
              )}
              {menuType === 'checkin-guied' && <CheckinGuiedMenus />}
              {menuType === 'settings' && <SettingsMenus />}
              {menuType === 'guides' && <GuideMenus />}
              {menuType === 'policy' && <PolicyMenus />}
            </div>
          )}
        </div>
        <div style={{ flexGrow: 1, width: '100%' }}>{children}</div>
      </Row>
    </Container>
  );
};

const Container = styled.div``;

const ButtonStyle = styled.div<{ $isActive?: boolean }>`
  min-width: 100px;
  text-align: center;
  a {
    font-weight: ${({ $isActive }) => ($isActive ? '700' : '400')};
    text-decoration: none;
    color: inherit;
  }
  padding-bottom: 16px;
  color: ${({ $isActive }) => ($isActive ? 'var(--point-color)' : 'inherit')};
  position: relative;
  top: 10px;
  border-bottom: 2px solid ${({ $isActive }) => ($isActive ? 'var(--point-color)' : 'transparent')};
`;

const ContextWrapper = styled.div<{ $isActive?: boolean }>`
  position: absolute;
  top: 50px;
  left: -30px;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  min-width: 200px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  pointer-events: ${({ $isActive }) => ($isActive ? 'auto' : 'none')};
  &:hover {
    background: #f0f0f0;
  }
`;

export default AdminLayout;
